<template>
  <div class="h5-container">
    <van-nav-bar
        class="top-bar"
        title="真伪查询"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    ></van-nav-bar>
    <div class="container-item">
      <van-card shadow="never" class="search-card">
        <template #desc>
          <van-field
              name="number"
              v-model="number"
              label="球杆编码"
              placeholder="请输入球杆编码"
              class="search-input"
          />
        </template>
      </van-card>

      <van-button class="search-btn" block @click="search">查询</van-button>
    </div>
    <!-- 核心修改：包裹Vant卡片，和搜索区卡片风格统一 -->
    <div class="result-container">
      <van-card shadow="never" class="result-card" v-if="htmlContent">
        <template #desc>
          <div class="content-item" v-html="htmlContent"></div>
        </template>
      </van-card>
    </div>
  </div>
</template>

<script>
import '@/assets/css/mobileGlobal.scss';
import { checkPortal } from "@/api/sales";
import { Dialog } from "vant";

export default {
  data() {
    return {
      number: '',
      htmlContent: '',
    }
  },
  created() {
    // this.selectProductByUser();
  },
  methods: {
    //顶部标题栏返回事件
    onClickLeft() {
      this.$router.push('/app_home');
    },

    showDialogMsg(message) {
      Dialog.alert({
        title: '查询结果',
        message: message,
        dangerouslyUseHTMLString: true
      });
    },
    // 真伪查询
    search() {
      if (!this.number) { // 优化判空逻辑
        this.showDialogMsg('请输入球杆编码');
        return;
      }
      //球杆编号
      const keyWord = this.number;
      //先清除之前的查询结果
      this.htmlContent ="";
      this.isCust = false;
      //查询真伪接口
      checkPortal(keyWord).then(res => {
        if (res.code === 200) {
          const data = res.data;
          const code = data.code;
          let msgStr = "";

          if (code === 5) {
            msgStr = `<p class="no-margin">此杆号查询次数较多，疑似克隆号，请联系经销商或者联系官方售后确认</p>
                                <p>官方售后咨询：<a href="tel:18603360681">18603360681</a></p>
                            `;
            this.htmlContent = msgStr;
          } else if (code === 0) {
            this.htmlContent = msgStr;
          } else if (code === 2) {
            msgStr = `<p>很遗憾，您所查询的杆号非璟点公司提供正品行货，没有售后保障。请联系官方售后电话或找附近经销商确认。</p>
                                <p>官方售后咨询：<a href="tel:18603360681">18603360681</a></p>
                            `;
            this.htmlContent = msgStr;
          } else if (code === 1) {
            let agent_name = "";
            if (data.agent_name && data.agent_name !== '') {
              agent_name = "，授权销售商为[" +'<span>'+ data.agent_name +'</span>'+ "]。";
            }
            msgStr = `
                                  <p>恭喜您！该编号[<span>${data.portal_number}</span>]商品为正品，请您放心使用。</p>
                                  <p>${data.portalSpecs?'该编号商品为['+'<span>'+data.portalSpecs+'</span>'+']':''}</p>
                                  <p>该编号商品出货日期为[<span>${data.create_time}</span>]${agent_name}</p>
                                  <p>该编号商品已查询[<span>${data.check_number}</span>]次</p>
                                  <p>上次查询时间[<span>${data.cx_time}</span>]</p>
                              `;
            this.htmlContent = msgStr;
          }
        } else {
          // 处理接口返回非200的情况
          Dialog.alert({
            title: '提示',
            message: res.returnMsg || '查询失败，请稍后重试',
          });
        }
      }).catch(err => {
        // 补充接口异常捕获
        Dialog.alert({
          title: '错误',
          message: '查询失败，请检查网络或稍后重试',
        });
      })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .van-icon-arrow-left {
  color: #0f0f0f !important;
}
::v-deep .van-nav-bar__text {
  color: #0f0f0f !important;
}
.top-bar {
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
}
.container-item {
  padding: 0 16px;
}
.search-card {
  margin: 16px 0;
  border-radius: 12px;
  height: 200px;
  background-image: url('~@/assets/img/h5/search_bj.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
}
.search-input {
  margin-top: 160px;
  border-radius: 10px;
  border-bottom: none;
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
}

.search-btn {
  width: 100%;
  height: 48px;
  border-radius: 8px;
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
  color: #000;
  font-size: 16px;
  font-weight: bold;
  border: none;
  margin-bottom: 16px;
  margin-top: 32px;
}
.no-margin {
  margin: 0;
}

// 新增：结果卡片容器样式
.result-container {
  padding: 0 16px;
  margin-top: 20px;
}
// 结果卡片样式，和搜索卡片风格统一
.result-card {
  border-radius: 12px;
  padding: 20px 16px;
  background-color: #fff;
}
// 核心修改：文字居中、调大行间距
:deep(.content-item) {
  width: 100%;
  text-align: center; // 文字水平居中
  p {
    font-size: 14px;
    line-height: 2; // 行间距调大，数值越大行距越宽
    margin: 0 0 8px 0; // 段落底部间距，避免文字挤在一起
    span{
      color: #B8860B;
    }
  }
  a {
    color: #B8860B;
    text-decoration: underline;
    font-weight: 500;
  }
}
</style>